import React, { Component } from 'react'
import style from './index.module.less'
import { ImageViewer } from './ImageViewer'
import { replaceEmojiToImg } from '@hlj/hlj-utils'
import twemoji from 'twemoji'
import Tags from './Tags'

class Index extends Component {
  formatInspirations = inspirations => {
    let ret = []
    inspirations.forEach(e => {
      if (e.media?.type == 1) {
        ret.push({
          type: 'image',
          url: e.media?.photo?.image_path ?? ''
        })
      } else {
        ret.push({
          type: 'video',
          url: e.media?.video?.origin_path ?? ''
        })
      }
    })
    return this.sortMediaData(ret)
  }

  // 对图片/视频文件排序处理，将视频文件提至最头部
  sortMediaData = arr => {
    let ret = [...arr]
    const videoIndex = ret.findIndex(f => f.type === 'video')
    if (videoIndex > -1) {
      const video = ret[videoIndex]
      ret.splice(videoIndex, 1)
      ret.unshift(video)
    }
    return ret
  }

  render() {
    const { noteList = [] } = this.props
    return (
      <div>
        <div className={style.header}>最新动态</div>
        <div className={style.list}>
          {noteList.map(item => {
            return (
              <div key={item.id} className={style.eachItem}>
                <div className={style.leftContent}>
                  <img src={item.user.avatar} />
                </div>
                <div className={style.rightContent}>
                  <p className={style.contentTip}>
                    <span>{item.user.nick}</span>
                    <span className={style.date}>{item.created_at}</span>
                  </p>
                  <h3 className={style.title}>{item.title}</h3>
                  {!!item.content && (
                    <p
                      className={style.desc}
                      dangerouslySetInnerHTML={{
                        __html: twemoji.parse(replaceEmojiToImg(item.content))
                      }}
                    />
                  )}
                  <div className={style.imgWrap}>
                    <ImageViewer
                      value={this.formatInspirations(item.inspirations)}
                    />
                  </div>
                  <div className={style.tagWrap}>
                    <Tags tags={item.marks} />
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        <p className={style.seeMore}>
          {noteList.length == 0 ? '暂无动态' : '更多动态请上婚礼纪app查看'}
        </p>
      </div>
    )
  }
}

export default Index
